<template>
  <RevLoadingScreen
    v-if="pending"
    :text="i18n(translations.loading)"
    variant="light"
  />
  <template v-else>
    <div v-if="orderDetails" class="h-full">
      <OrderLineSelect
        v-if="shouldShowOrderLineSelect"
        :order-lines
        @continue="handleContinue"
      />
      <CancelOrderLines
        v-else
        :order
        :order-lines
        :selected-order-lines-ids="currentSelectedOrderLinesIds"
        @order-cancelled="emit('refresh-orders')"
      />
    </div>
    <div v-else>
      {{ i18n(translations.orderNotFound) }}
    </div>
  </template>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { getOrderDetails } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants-orders/merchant-orders-page'
import type { GetSellerXpOrderDetails } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants-orders/merchant-orders-pages.types'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'

import type { Order } from '~/scopes/orders/pages/components/Tab/Tab.types'

import translations from './OutOfStockIssue.translations'
import CancelOrderLines from './components/CancelOrderLines.vue'
import OrderLineSelect from './components/OrderLineSelect.vue'

const props = defineProps<{
  order: Order
}>()

const emit = defineEmits<{
  (e: 'refresh-orders'): void
}>()

const i18n = useI18n()
const selectedOrderLinesIds = ref<string[]>([])

const { data: orderDetails, pending } = useHttpFetch(getOrderDetails, {
  pathParams: {
    orderId: props.order.id,
  },
  queryParams: {
    view: 'simple',
  },
})

const orderLines = computed<GetSellerXpOrderDetails['orderLines']>(
  () => orderDetails.value?.orderLines || [],
)

const shouldShowOrderLineSelect = computed(
  () => orderLines.value.length > 1 && selectedOrderLinesIds.value.length === 0,
)

const currentSelectedOrderLinesIds = computed<string[]>(() => {
  return orderLines.value.length > 1
    ? selectedOrderLinesIds.value
    : orderLines.value.map((orderLine) => orderLine.id.toString())
})

function handleContinue(orderLineIds: string[]) {
  selectedOrderLinesIds.value.push(...orderLineIds)
}
</script>
